<template>
    <b-form-row>
        <b-modal size="xl" button-size="sm" ref="finderModal" :title="prefix + title">
            <EmpresaList @onDblClickEmpresaSelect="empresaSelect" :title="prefix + title + ' >'" :multiple="multiple" />
        </b-modal>
        <lg-form-input-finder v-model="valueLocal" fieldDescription="razaoSocial" :label="label"
            invalidFeedback="Empresa deve ser informada!" description="" @clear="handleClear">
            <template #prepend>
                <b-button @click="show" class="btn-input-finder" pressed>
                    <b-icon icon="search" />
                </b-button>
            </template>
        </lg-form-input-finder>
    </b-form-row>
</template>

<script>
import LgFormInputFinder from "@/core/components/Form/LgFormInputFinder.vue";
import EmpresaList from "@/modules/cadastros/empresa/EmpresaList.vue";

export default {
    components: { LgFormInputFinder, EmpresaList },

    props: {
        id: String,
        onSelect: Function,
        onClear: Function,
        value: [Object, Array],
        prefix: {
            type: String,
            default: "",
        },
        label: {
            type: String,
            default: "Empresa",
        },
        multiple: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            valueLocal: this.value,
            title: "Empresa",
        };
    },

    methods: {
        show() {
            this.$refs.finderModal.show();
        },

        handleClear() {
            this.$emit("onSelect");
        },

        empresaSelect(item) {
            this.$emit("onSelect", item);
            this.$refs.finderModal.hide();
        },
    },
};
</script>
